var path = 'app/features/games/games.tpl.html';
var html = "<div id=\"mission-container\">\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;